'use client';

import DocumentDefaultPage from '@/lib/components/document/DefaultPage';
import Headline from '@/lib/components/ui/Headline';
import Section from '@/lib/components/ui/Section';
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

const Error = ({ error }: { error: Error & { digest?: string; statusCode: number } }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, []);

  return (
    <DocumentDefaultPage>
      <Section className="c-bodytext">
        <Headline>500 Fehler</Headline>
        <p>Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.</p>
      </Section>
    </DocumentDefaultPage>
  );
};

export default Error;
